export const trafficTypes = {
  ADD_DELETE_ACTION_RETURN_LOCATION:
    'traffic_add_delete_action_return_location',
  CLEAR: 'traffic_clear',
  CLEAR_DOCS: 'traffic_clear_docs',
  EARLIEST: 'traffic_earliest',
  FIND: 'traffic_find',
  FIND_BY_ID: 'traffic_find_by_id',
  LOAD: 'traffic_load',
  LOADING_SEARCH: 'traffic_loading_search',
  SEARCH: 'traffic_search',
  SEARCH_UNDERWRITERS: 'traffic_search_underwriters',
};
